import * as types from './actionTypes'
import { incidentsPagination } from '../../utils/constants'
import { getMappedObjectsByKey } from './selectors'

export const initialState = {
  hasMoreIncidents: true,
  incidents: [],
  mappedIncidentsById: {},
  loads: [],
}
const Incidents = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_INCIDENTS_BY_STATUS: {
      return {
        ...state,
        incidents: [...state.incidents, ...payload],
        hasMoreIncidents: payload.length >= incidentsPagination,
        mappedIncidentsById:
          getMappedObjectsByKey([...state.incidents, ...payload], 'id'),
      }
    }

    case types.FETCH_INCIDENTS_BY_ID: {
      return {
        ...state,
        mappedIncidentsById: {
          ...state.mappedIncidentsById,
          [payload.id]: {
            ...state.mappedIncidentsById[payload.id],
            ...payload.data,
          },
        },
      }
    }

    case types.FETCH_LOADS_FOR_INCIDENT: {
      return {
        ...state,
        loads: [...payload],
      }
    }

    case types.CLEAR_INCIDENTS_BY_STATUS: {
      return {
        ...state,
        incidents: [],
        hasMoreIncidents: true,
        mappedIncidentsById: {},
      }
    }


    default:
      return state
  }
}

export default Incidents
